module.exports = __webpack_public_path__ + "img/working-process3.4faf52e8.jpg";